export default {
    //tracerbaseURL: 'http://localhost:5555',
    tracerbaseURL: 'https://gokouscheduler.com:5555',
    //tracerbaseURL: 'https://chat-man.com:5555',
    autoLogout:true,
}